exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html {\n  font-size: 16px; /* 锁定基准，忽略系统设置 */\n  -webkit-text-size-adjust: 100%; /* 禁止iOS Safari自动调整 */\n  -moz-text-size-adjust: 100%;\n   -ms-text-size-adjust: 100%;\n       text-size-adjust: 100%; /* 标准属性 */\n}\n\n@supports (bottom: env(safe-area-inset-bottom)){\n\n    :root {\n      --sat: env(safe-area-inset-top);\n      --sar: env(safe-area-inset-right);\n      --sab: env(safe-area-inset-bottom);\n      --sal: env(safe-area-inset-left);\n    }\n    /* padding-bottom: env(safe-area-inset-bottom)!important; */\n  \n}\n\n\n@supports (bottom: constant(safe-area-inset-bottom)){\n\n  :root {\n    --sat: constant(safe-area-inset-top);\n    --sar: constant(safe-area-inset-right);\n    --sab: constant(safe-area-inset-bottom);\n    --sal: constant(safe-area-inset-left);\n  }\n  /* padding-bottom: env(safe-area-inset-bottom)!important; */\n\n}\n\ninput[aria-hidden=true]{\n  display: none !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./src/App.css
// module id = 1782
// module chunks = 0